const config = {
  API_ENDPOINT: 'https://dry-bastion-25929.herokuapp.com/api',
  // API_ENDPOINT: 'http://localhost:8000/api',
  // API_KEY: process.env.REACT_APP_API_KEY,
  TOKEN_KEY: 'tp-capstone-auth-token',
};


export default config;